import { styled } from 'styled-components'
import { ArrowIcon, CameraIcon } from '../../../assets/Icons'
import { ColorType, HashtagChips } from '../../../components/chips'
import { Text } from '../../../components/common'
import { theme } from '../../../styles'
import React, { useEffect, useRef, useState } from 'react'
import { BigButtons } from '../../../components/Buttons'
import { useNavigate } from 'react-router-dom'
import { FoodRecordResult } from './FoodRecordResult'
import { useRecoilState, useRecoilValue } from 'recoil'
import { foodAIDetectionLabels, foodLabelsAnalysisResult, userAccessToken } from '../../../store/recoil'
import { Modal } from '../../../components/modal'
import { IconContainer } from '../../../assets/Icons/characters/Belly'
import { Row } from '../../../styles'
import { Welly } from '../../../assets/Icons/characters/Welly'
import { postFoodDetection } from '../../../network/apis/fastApis/foodDetection'
import { postUploadImage } from '../../../network/apis/dailyRecord'

interface MealTypesInterface {
  id: number
  time: string
}
const MealTypes: MealTypesInterface[] = [
  { id: 1, time: '아침' },
  { id: 2, time: '점심' },
  { id: 3, time: '저녁' },
  { id: 4, time: '기타' }
]
export interface FoodResultLabelsInterface {
  labels: string[]
}
export interface FoodLabelsAnalysisResultInterface {
  image: string
  mealtime: string
  meal: string[]
  fodmapList: {
    lowFodmap: string[]
    highFodmap: string[]
  }
  nutrient: {
    fructose: {
      value: number
      graph: number
    }
    sucrose: {
      value: number
      graph: number
    }
    lactose: {
      value: number
      graph: number
    }
    maltose: {
      value: number
      graph: number
    }
    fiber: {
      value: number
      graph: number
    }
  }
}

export const FoodRecord = () => {
  const [mealTime, setMealTime] = useState<number>()
  const [imageSrc, setImageSrc] = useState<string>()
  const [s3ImageUrl, setS3ImageUrl] = useState<string>()
  const hiddenFileInput = useRef<HTMLInputElement>(null)
  const [showResult, setShowResult] = useState<boolean>(false)
  const [uploadFile, setUploadFile] = useState<File>()
  const [modalOpen, setModalOpen] = useState(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [foodResultLabels, setFoodResultLabels] = useRecoilState(foodAIDetectionLabels)

  const foodResult = useRecoilValue(foodLabelsAnalysisResult)
  const accessToken = useRecoilValue(userAccessToken)
  const navigate = useNavigate()

  const handleClick = () => {
    hiddenFileInput.current?.click()
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileUploaded = event.target.files?.[0]

    if (fileUploaded) {
      setUploadFile(fileUploaded)

      const reader = new FileReader()
      reader.readAsDataURL(fileUploaded)

      return new Promise<void>(resolve => {
        reader.onload = () => {
          setImageSrc(reader.result instanceof ArrayBuffer ? '' : reader.result || '')
          resolve()
        }
      })
    }
  }

  useEffect(() => {
    if (foodResult.image) setShowResult(true)
    else setShowResult(false)
    const mealTime = MealTypes.find(type => type.time === foodResult.mealtime)?.id
    setMealTime(mealTime)
  }, [foodResult.image])

  // 이미지 s3에 업로드
  const postImage = async () => {
    if (uploadFile !== undefined && mealTime !== undefined) {
      setIsLoading(true)
      setModalOpen(true)

      const formData = new FormData()
      formData.append('image', uploadFile!)

      postUploadImage(accessToken, formData).then(imgUrl => {
        setS3ImageUrl(imgUrl)
        postFoodDetection(imgUrl).then(res => {
          setIsLoading(false)
          setFoodResultLabels(res?.labels)
        })
      })

      // const presignedUrl = await res.text();

      /* const uploadRes = await fetch(presignedUrl, {
      method: "put",
      headers: {
        //  "content-type": "application/xml",
        "content-type": uploadFile?.type!,
      },
      body: uploadFile,
    });
    console.log(uploadRes);*/
    } else {
      if (imageSrc === undefined && mealTime !== undefined) alert('사진을 첨부해주세요')
      else if (imageSrc !== undefined && mealTime === undefined) alert('식사 종류를 입력해주세요')
      else alert('사진과 식사 종류를 입력해주세요')
    }
  }

  return (
    <Container>
      <FoodRecordSection result={showResult}>
        <div>
          <div className="icon-container" onClick={() => navigate(-1)}>
            <ArrowIcon />
          </div>
          <Row gap={10} alignItems="flex-end" style={{ height: '30px' }}>
            <IconContainer width={50} height={50}>
              <Welly />
            </IconContainer>
            <Text $Typo="Title1" $paletteColor="Gray6">
              어떤 식사를 하셨나요?
            </Text>
          </Row>

          <ImageContainer onClick={handleClick} image={foodResult.image ? foodResult.image : imageSrc}>
            <input accept="image/*" multiple type="file" style={{ display: 'none' }} onChange={e => !foodResult.image && handleChange(e)} ref={hiddenFileInput} />
            {imageSrc === undefined && !foodResult.image ? <CameraIcon /> : <Img src={foodResult.image ? foodResult.image : imageSrc} />}
          </ImageContainer>

          <Text $Typo="Title2" $paletteColor="Gray6">
            식사 종류
          </Text>

          <ChipsContainer>
            {MealTypes.map((type: MealTypesInterface) => (
              <HashtagChips key={type.id} color={type.id === mealTime ? ColorType.MainOrange : ColorType.Gray} onClick={() => !foodResult.image && setMealTime(type.id)}>
                {type.time}
              </HashtagChips>
            ))}
          </ChipsContainer>
        </div>

        {!showResult && (
          <BigButtons active={imageSrc !== undefined && mealTime !== undefined} onClick={() => postImage()}>
            분석하기
          </BigButtons>
        )}
      </FoodRecordSection>
      {modalOpen && <Modal imgUrl={s3ImageUrl!} mealTime={MealTypes.find(type => type.id === mealTime)?.time || '기타'} foodResultLabels={isLoading ? [] : foodResultLabels} isLoading={isLoading} modalOpen={modalOpen} setShowResult={setShowResult} setModalOpen={setModalOpen} />}
      {showResult && <FoodRecordResult imageSrc={imageSrc!} />}
    </Container>
  )
}

const Container = styled.div`
  height: 100%;
`
const FoodRecordSection = styled.div<{ result?: boolean }>`
  width: 100%;
  height: ${({ result }) => (result ? '100%' : 'calc(100vh - 30px)')};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 3%;

  .icon-container {
    padding: 20px 0 30px 0;
    width: fit-content;
  }

  @media screen and (max-height: 700px) {
    padding: 3% 3% 0 3%;

    .icon-container {
      padding: 20px 0;
      width: fit-content;
    }
  }
`
const ImageContainer = styled.div<{ image?: string }>`
  width: 100%;
  height: 330px;
  background: ${({ image }) => (image !== undefined ? theme.palette.White : theme.palette.Gray2)};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0 30px 0;

  @media screen and (max-height: 700px) {
    margin: 10px 0 20px 0;
  }
`
const ChipsContainer = styled.div`
  width: 100;
  display: flex;
  gap: 7px;
  padding: 15px 0;
`
const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`
